import { render, staticRenderFns } from "./OrderPayment.vue?vue&type=template&id=7f5e37f0&scoped=true"
import script from "./OrderPayment.vue?vue&type=script&lang=js"
export * from "./OrderPayment.vue?vue&type=script&lang=js"
import style0 from "./OrderPayment.vue?vue&type=style&index=0&id=7f5e37f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5e37f0",
  null
  
)

export default component.exports